import PeoplesoftReaderNode from './types/peoplesoft-reader';
import PeoplesoftWriterNode from './types/peoplesoft-writer';

export const peoplesoftNodes = {
  peoplesoftReader: PeoplesoftReaderNode,
  peoplesoftWriter: PeoplesoftWriterNode,
};
